var INITIAL = 'initial';
var SUCCESS = 'success';
var ERROR = 'error';
var PENDING = 'pending';
export { ERROR, INITIAL, PENDING, SUCCESS };